/**
 * Converts route text to a positive integer ID or an absent value.
 *
 * Postconditions: Falsy input and case-insensitive create return undefined. Other text uses
 * Number conversion and must yield an integer greater than zero; no safe-integer bound or
 * decimal-only syntax restriction is imposed.
 */
export const parseRouteId = (value?: string | null): number | undefined => {
    if (!value || value.toLowerCase() === "create") {
        return undefined;
    }

    const id = Number(value);
    return Number.isInteger(id) && id > 0 ? id : undefined;
};
